import React from 'react'
import Container from '../../Container/Container'
import { Pagination,Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "./SliderBrand.css"
// images
import Asus from '../../../assets/images/brand/ASUS.png'
import CoolerMaster from '../../../assets/images/brand/Cooler_Master.png'
import GSKILL from '../../../assets/images/brand/G.SKILL_.png'
import Kingston from '../../../assets/images/brand/Kingston.png'
import PNY from '../../../assets/images/brand/PNY.png'
import WD from '../../../assets/images/brand/Western_Digital.png'
import corsair from '../../../assets/images/brand/corsair.png'
import intel from '../../../assets/images/brand/intel.png'
import lexar from '../../../assets/images/brand/lexar.png'
import samsung from '../../../assets/images/brand/samsung.jpg'


function SliderBrand() {
    return (
        <>
            <Container class1=''>
                <div className="row sec_brand">
                    <div className="col-12 ">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            500: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 4,
                                spaceBetween: 40,
                            },
                            1024: {
                                slidesPerView: 5,
                                spaceBetween: 50,
                            },
                        }}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                          }}
                        modules={[Pagination,Autoplay]}
                        className="mySwiper "
                    >
                        <SwiperSlide><img className='img-fluid brand-swiper' src={Asus} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={CoolerMaster} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={GSKILL} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={Kingston} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={PNY} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={WD} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={corsair} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={intel} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={lexar} alt="" /></SwiperSlide>
                        <SwiperSlide><img className='img-fluid brand-swiper' src={samsung} alt="" /></SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </Container >
        </>
    )
}

export default SliderBrand